import { ChakraProvider as CoreChakraProvider } from '@chakra-ui/react';
import { ChakraProvider as ChakraProviderV2 } from '@chakra-ui/react-v2';
import type { ChakraProviderProps as ChakraProviderV2Props } from '@chakra-ui/react-v2';

import { PreferredDateFormat } from '@frontend/api';
import { theme } from '@frontend/legacy-components';
import { TemporalSettingsProvider } from '@frontend/utils';

import { v3System } from './v3System';

export type ChakraProviderProps = Pick<
  ChakraProviderV2Props,
  'children' | 'resetCSS'
> & {
  preferredDateFormat: PreferredDateFormat;
};

export const ChakraProvider = ({
  children,
  preferredDateFormat,
  resetCSS = false,
}: ChakraProviderProps) => (
  <CoreChakraProvider value={v3System}>
    <ChakraProviderV2 theme={theme} resetCSS={resetCSS}>
      <TemporalSettingsProvider preferredDateFormat={preferredDateFormat}>
        {children}
      </TemporalSettingsProvider>
    </ChakraProviderV2>
  </CoreChakraProvider>
);
